export enum JobAlertTextColor {
    Light = 'light',
    Dark = 'dark'
}

export type JobAlertTextColorType = JobAlertTextColor.Light | JobAlertTextColor.Dark;
export class JobAlertColor {
    name: string;
    code: string;
    textColor: JobAlertTextColorType;

    constructor(name: string, code: string, textColor: JobAlertTextColorType) {
        this.name = name;
        this.code = code;
        this.textColor = textColor;
    }

    get hexCode(): string {
        return `#${this.code}`;
    }
}
export const JobAlertColors: JobAlertColor[] = [
    new JobAlertColor('Yellow', 'F9F7A2', JobAlertTextColor.Dark),
    new JobAlertColor('Lime', 'D6DB6A', JobAlertTextColor.Dark),
    new JobAlertColor('Light Pink', 'EBBAF4', JobAlertTextColor.Dark),
    new JobAlertColor('Teal', '61BCBC', JobAlertTextColor.Dark),
    new JobAlertColor('Dark Pink', 'E286D5', JobAlertTextColor.Dark),
    new JobAlertColor('Purple', '8A51B7', JobAlertTextColor.Light),
    new JobAlertColor('Brown', '715A5A', JobAlertTextColor.Light)
];
